var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v("Allow Authorization"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://blogpfthumb-phinf.pstatic.net/MjAxOTA2MThfMjE2/MDAxNTYwODM2ODQ5MDk5.QteT5YL-OesHK0KxOdLg_5sTkIOvAqT10uVjT8rdNrsg.IIvp-gexFczdgl3bbJL4riqyDoTLAJkXOSSbfJEB6JUg.PNG.blogpeople/%255BTeamBlog%255DProfile%25402x.png?type=s1",
                              alt: "Naver blog",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("네이버 블로그")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Trending")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.YOUTUBE_TRENDING,
                                    expression: "formData.YOUTUBE_TRENDING",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch1",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.formData.YOUTUBE_TRENDING
                                  )
                                    ? _vm._i(
                                        _vm.formData.YOUTUBE_TRENDING,
                                        null
                                      ) > -1
                                    : _vm.formData.YOUTUBE_TRENDING,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.formData.YOUTUBE_TRENDING,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.formData,
                                        "YOUTUBE_TRENDING",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch1" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("My Subscriptions")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.YOUTUBE_TRENDING,
                                    expression: "formData.YOUTUBE_TRENDING",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch2",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.formData.YOUTUBE_TRENDING
                                  )
                                    ? _vm._i(
                                        _vm.formData.YOUTUBE_TRENDING,
                                        null
                                      ) > -1
                                    : _vm.formData.YOUTUBE_TRENDING,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.formData.YOUTUBE_TRENDING,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.formData,
                                        "YOUTUBE_TRENDING",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch2" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Communities")]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.YOUTUBE_TRENDING,
                                    expression: "formData.YOUTUBE_TRENDING",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "customSwitch1",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.formData.YOUTUBE_TRENDING
                                  )
                                    ? _vm._i(
                                        _vm.formData.YOUTUBE_TRENDING,
                                        null
                                      ) > -1
                                    : _vm.formData.YOUTUBE_TRENDING,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.formData.YOUTUBE_TRENDING,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "YOUTUBE_TRENDING",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.formData,
                                        "YOUTUBE_TRENDING",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "customSwitch1" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.YOUTUBE_MY_SUBSCRIPTION,
                                expression: "formData.YOUTUBE_MY_SUBSCRIPTION",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Enter an URL...",
                            },
                            domProps: {
                              value: _vm.formData.YOUTUBE_MY_SUBSCRIPTION,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "YOUTUBE_MY_SUBSCRIPTION",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-input-group-append" }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.YOUTUBE_URL,
                                expression: "formData.YOUTUBE_URL",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Enter search keyword...",
                            },
                            domProps: { value: _vm.formData.YOUTUBE_URL },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "YOUTUBE_URL",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c(
                            "div",
                            { staticClass: "go-form-feedback-invalid" },
                            [_vm._v("This URL is invalid! Please try again.")]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.YOUTUBE_KEYWORD,
                                expression: "formData.YOUTUBE_KEYWORD",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: "Sample Input",
                            },
                            domProps: { value: _vm.formData.YOUTUBE_KEYWORD },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "YOUTUBE_KEYWORD",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-form-feedback" }, [
                          _c("div", { staticClass: "go-form-feedback-valid" }, [
                            _vm._v(
                              "Your verification code has been successfully verified."
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "separator" }, [
                  _c("div", { staticClass: "line" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("OR")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }),
                ]),
                _vm._v(" "),
                _c("button", { staticClass: "google-btn" }, [
                  _c("img", {
                    staticClass: "google-icon",
                    attrs: {
                      src: "https://www.svgrepo.com/show/475656/google-color.svg",
                      alt: "Google Logo",
                    },
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("scrap-agent.login-common.login")) +
                      " Google\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v("Back")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleAddDataSourceItem.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [_vm._v("Next")]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }